export class ServiceFieldValueDetails {
  name: string
  serviceFieldId: number
  value: string|undefined

  constructor(name: string, serviceFieldId: number, value: string|undefined) {
    this.name = name
    this.serviceFieldId = serviceFieldId
    this.value = value
  }
}
